<template>
  <!-- info and auth bar -->
  <div class="flex flex-row items-center py-2 px-4 border-b select-none">
    <button :class="$route.path !== '/dashboard' || 'invisible'" class="btn btn-link"
            @click="$router.push('/dashboard')">
      Zum Dashboard
    </button>
    <button :class="backName || 'invisible'" class="btn btn-link" @click="$router.push(backLink)">
      Zurück zum {{ backName }}
    </button>

    <span class="ml-auto mr-auto font-bold">{{ title || "Caritas Quiz-App Inhaltsverwaltung" }}</span>

    <span v-if="$store.state.user">Angemeldet als {{ $store.state.user.displayName }}</span>
    <button class="btn btn-link" @click="auth.signOut() && $store.commit('addMessage', 'Erfolgreich abgemeldet.')">
      Abmelden
    </button>
  </div>
</template>
<script>
import { auth } from "../plugins/firebase";

export default {
  props: ["title", "backName", "backLink"],
  data() {
    return {
      auth
    }
  }
}
</script>